import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import SEO from './SEO';
import {
  pagesMeta, siteConfig, faqItems, getBlogPostBySlug, getLocationById, getServiceById,
} from '../data/seo';
import { generateFAQSchema, generateLocalBusinessSchema } from '../utils/seo';

const legalPages = {
  '/privacy-policy': {
    title: 'Privacy Policy | CHOMP Pet Dental',
    description: 'How CHOMP Pet Dental handles information provided through our website and veterinary services.',
    canonical: `${siteConfig.url}/privacy-policy`,
  },
  '/terms-of-service': {
    title: 'Terms of Service | CHOMP Pet Dental',
    description: 'Terms for the CHOMP Pet Dental website and veterinary services in Fort Lauderdale.',
    canonical: `${siteConfig.url}/terms-of-service`,
  },
};

/** Shared by the browser and the static build, including social preview metadata. */
export default function RouteMetadata() {
  const { pathname } = useLocation();
  const canonical = `${siteConfig.url}${pathname}`;
  const coreMeta = [...Object.values(pagesMeta), ...Object.values(legalPages)]
    .find(meta => meta.canonical === canonical);
  const [, section, slug, extra] = pathname.split('/');
  const isDetail = Boolean(!extra && slug && (
    (section === 'blog' && getBlogPostBySlug(slug)) ||
    (section === 'locations' && getLocationById(slug)) ||
    (section === 'services' && getServiceById(slug))
  ));
  const meta = coreMeta || (!isDetail ? {
    title: pathname === '/spot' ? "Spot's Page | CHOMP Pet Dental" : 'Page Not Found | CHOMP Pet Dental',
    description: pathname === '/spot' ? 'A little fun from Chomp.' : 'Find pet dental services, contact information, and appointments at Chomp.',
    canonical,
    noindex: true,
  } : undefined);

  return (
    <>
      <Helmet>
        <script id="chomp-business" type="application/ld+json">
          {JSON.stringify(generateLocalBusinessSchema())}
        </script>
      </Helmet>
      {meta && (
        <SEO meta={meta} schema={pathname === '/' ? generateFAQSchema(faqItems) : undefined} />
      )}
    </>
  );
}
